import React, { useContext } from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import Grid from "../shared/grid"
import {
  SectionContainer,
  Title,
  TextContent,
  Headline,
  P,
  SocialRow,
  SocialLink,
  MosaicImage,
  SliderContainer,
} from "./culture.style"
import { UIContext } from "../shared/layout"
import externalLinks from "../../external-links"
import Slider from "react-slick"

export default function CultureSection() {
  const query = useStaticQuery(graphql`
    query {
      instagramIcon: file(
        relativePath: { eq: "4_COMPANY/Careers/Desktop/insta_icon.svg" }
      ) {
        publicURL
      }
      mosaicImg: file(
        relativePath: { eq: "4_COMPANY/Careers/Desktop/employee_mosaic.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440, quality: 90) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      galleryImg1: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Mobile/Employee Mosaic Photos/employee_mosaic_1.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      galleryImg2: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Mobile/Employee Mosaic Photos/employee_mosaic_2.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      galleryImg3: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Mobile/Employee Mosaic Photos/employee_mosaic_3.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      galleryImg4: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Mobile/Employee Mosaic Photos/employee_mosaic_4.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      galleryImg5: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Mobile/Employee Mosaic Photos/employee_mosaic_5.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      galleryImg6: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Mobile/Employee Mosaic Photos/employee_mosaic_6.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 600) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const {
    state: { breakpoint, clientLoaded },
  } = useContext(UIContext)

  return (
    <SectionContainer>
      <Grid>
        <Title>Our Culture</Title>
        <TextContent>
          <Headline>
            At Mappedin, our core values stand for everything we do and how we
            win together.
          </Headline>{" "}
          <P>
            We encourage our team to learn fast by making decisions with less
            information, to share the credit and take the blame, to put our
            customers first above all else, and to lead by example.
          </P>{" "}
          <P>
            This culture is what sets Mappedin apart and is the guiding
            principle for our success in the industry.
          </P>
        </TextContent>
        {breakpoint === "sm" && clientLoaded && (
          <SliderContainer>
            <Slider dots>
              <Img
                alt="A gallery of Mappedin employees at company events"
                fluid={query.galleryImg1.childImageSharp.fluid}
              />
              <Img alt="" fluid={query.galleryImg2.childImageSharp.fluid} />
              <Img alt="" fluid={query.galleryImg3.childImageSharp.fluid} />
              <Img alt="" fluid={query.galleryImg4.childImageSharp.fluid} />
              <Img alt="" fluid={query.galleryImg5.childImageSharp.fluid} />
              <Img alt="" fluid={query.galleryImg6.childImageSharp.fluid} />
            </Slider>
          </SliderContainer>
        )}
        <SocialRow>
          <img alt="Instagram" src={query.instagramIcon.publicURL} />
          <SocialLink
            to={externalLinks.instagram}
            target="_blank"
            rel="noreferrer"
          >
            Follow Us On Instagram{" "}
            {breakpoint === "sm" ? "@mappedinatwork" : ">"}
          </SocialLink>
        </SocialRow>
        <MosaicImage fluid={query.mosaicImg.childImageSharp.fluid} />
      </Grid>
    </SectionContainer>
  )
}
